import { Component, OnInit, Injector, Input, ElementRef, ViewContainerRef,ViewChild, OnChanges } from '@angular/core';
import {  BaseComponent } from "../../base.component";
import { LayoutService } from '../../../Services/layout/layout.service';
import {includes, isEmpty } from 'lodash';

@Component ({
 selector: 'custom-button-list',
 template: `
 <div class="custom-button-list-container" *ngIf="control">   
 <control *ngFor="let button of control.attributes.customButtons"
 context="page"
 [control]="button"
 [ngClass]="{ left: button.attributes.float === 'left', right: button.attributes.float === 'right' }">
</control>
  </div>
 `, 
 styleUrls: ['./custom-button-list.component.scss']
})

export class CustomButtonListComponent extends BaseComponent implements OnInit {
  constructor(injector: Injector, private LayoutService: LayoutService) {
    super(injector)
  }

  ngOnInit() {
    // this.LayoutService.staticLayout.subscribe((data) => {
    //     if(data){
            
    //     }
    //     });
  
  }
}